import { gql } from "@apollo/client"

const DELETE_EVENT_SCHEDULED_ACTION_MUTATION = gql`
  mutation($input: DeleteEventScheduledActionInput!) {
    deleteEventScheduledAction(input: $input)
  }
`

export { DELETE_EVENT_SCHEDULED_ACTION_MUTATION }